export class Debouncer {
  private static timers = new Map<string, number>();

  static debounce(key: string, fun: Function, timeInMillis: number) {
    clearTimeout(this.timers.get(key));
    let timeId = setTimeout(fun, timeInMillis);
    this.timers.set(key, timeId);
  }
}
